import React from 'react'
import { Box, CircularProgress } from '@mui/material'
import { LoadingViewProps } from '../types'

const LoadingView: React.FC<LoadingViewProps> = ({ isLoading }) => {
  if (!isLoading) return null

  return (
    <Box display="flex" justifyContent="center" my={4}>
      <CircularProgress />
    </Box>
  )
}

export default LoadingView
